module.exports = __webpack_public_path__ + "static/img/pledge4.2087636.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pledge4.png
// module id = 5Q/t
// module chunks = 0